import * as angular from "angular";
import {IController} from "angular";

export class BringozColorPickerComponent implements IController {
  color: any;
  onChange: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozColorPicker', {
    bindings: {
      color: '<',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-color-picker/bringoz-color-picker.html',
    controller: BringozColorPickerComponent
  });
